import lodashCloneDeep from "lodash/cloneDeep";

export const GEOLOCATION_PRECISIONS = [
  {
    id: 1,
    name: "Asset / Building",
    detected: true,
    political: true,
    maritime: true, // Acurate
  },
  {
    id: 2,
    name: "Street / Neighbourhood",
    detected: true,
    political: true,
    maritime: false,
  },
  {
    id: 3,
    name: "City",
    detected: true,
    political: true,
    maritime: true, //estimated
  },
  {
    id: 4,
    name: "Country",
    detected: true,
    political: true,
    maritime: true, //Unknown
  },
  {
    id: 9,
    name: "State",
    detected: true,
    political: false,
    maritime: false,
  },
];

export function filterPrecisionsByEventType(type) {
  return lodashCloneDeep(GEOLOCATION_PRECISIONS).filter((precision) => {
    if (type === "all") {
      return true;
    }
    if (type === "security") {
      return precision["political"];
    }
    if (type === "verified") {
      return precision["political"] || precision["maritime"];
    }
    return precision[type];
  });
}

export function filterPrecisionIdsByEventType(type, ids) {
  let viableOptions = filterPrecisionsByEventType(type).map((precision) => {
    return precision.id;
  });
  return ids.filter((id) => {
    return viableOptions.includes(id);
  });
}
